// import { motion } from "framer-motion";
// import { Container } from "react-bootstrap";
import { Helmet } from 'react-helmet-async';
import React from 'react'
import styled from "styled-components";

// ----------------------------------------------------------------------

function  Page404() {
  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - PAge Not Found!</title>
      </Helmet>
      <MainSection>
            <div>
              <div className="imgConainer">
              <img src="/assets/img/404.png" alt="" />
              </div>
              <p >
                Sorry, page not found!
              </p>
              <p >
              We couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.
            </p>
            </div>
            {/* <div>
            <p >
              We couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.
            </p>
          </div> */}
      </MainSection>
    </React.Fragment>
  );
}
export default  Page404;

const MainSection = styled.section`

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  .imgConainer {
    width: 100%;
    // height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 100%;
    max-width: 400px;
    height: 100%;
  }
  p {
    font-size: 20px;
    color: #fff;
    text-align: center;
    margin-top: 20px;
    padding-left:10px;
    padding-right:10px;
  }
  `;

